import { render, staticRenderFns } from "./Parametrizacion.vue?vue&type=template&id=b665d10a&"
import script from "./Parametrizacion.vue?vue&type=script&lang=js&"
export * from "./Parametrizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports